import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { tabTypes } from "../constants/tab-types";
import { FIXED_SCROLL_POSITION_OFFSET } from "../util/mediaConstants";

export default function useFixedHeader() {
  const [isHeaderFixed, setHeaderFixed] = React.useState(false);
  const { tabType } = useParams();

  useEffect(() => {
    const checkScroll = () => {
      // we only want to show fixed header for the content tab and drug details tab
      const isFixed =
        (tabType === undefined || tabType === tabTypes.DETAILS) &&
        window.scrollY > FIXED_SCROLL_POSITION_OFFSET;

      setHeaderFixed(isFixed);
    };

    window.addEventListener("scroll", checkScroll, false);
    return () => window.removeEventListener("scroll", checkScroll);
  }, [isHeaderFixed, tabType]);

  return { isHeaderFixed };
}
